import React from 'react';
import PropTypes from 'prop-types';
import FormRadioGroupContainer from '../../../redux/containers/FormRadioGroupContainer';
import ModemDeliveryAddress from '../ModemDeliveryAddress/ModemDeliveryAddress';
import FormTextareaContainer from '../../../redux/containers/FormTextareaContainer';

const ModemDelivery = (props) => {
  const instPlaceholder = 'Enter your instructions here (optional, maximum 30 characters)';
  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h3 className="half-charcoal">Modem delivery details</h3>
            <p>We want to make sure you get your whizzy modem sent to the right place.</p>
            <p>Where do you want it sent to?</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <FormRadioGroupContainer
              name="modemDelivery"
              radioButtons={[{
                id: 'same',
                label: 'Same as connection address',
                autotestClass: 'autotest-same'
              }, {
                id: 'different',
                label: 'Different delivery address',
                autotestClass: 'autotest-different'
              }]}
            />
          </div>
        </div>
      </div>
      {
        props.showModemDeliveryAddress &&
        <ModemDeliveryAddress />
      }
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-8">
            <small>
              Delivery instructions are a best effort endeavour and the responsibility is on the courier company to
              follow through. Courier deliveries take place Monday to Friday and you&apos;ll
              need to sign for the package.
            </small>
            <FormTextareaContainer
              name="modemDeliveryInstructions"
              placeholder={instPlaceholder}
              autotestClass="autotest-modem-delivery-instructions"
              maxLength={30}
              rows={2}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

ModemDelivery.propTypes = {
  showModemDeliveryAddress: PropTypes.bool
};

export default ModemDelivery;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/ModemDelivery/ModemDelivery.js
 **/